
export default {
  data() {
    return {};
  },
  methods: {
    isPowerChannel(channel){
      // 25は固定。 電源チャンネル // ch=16018
      return channel.category2_number === null && channel.category3_id == 25
    },
  }
};
